import { onCLS, onINP, onFCP, onLCP, onTTFB, ReportOpts } from "web-vitals";

const reportWebVitals = (onPerfEntry?: ReportOpts) => {
  onCLS(console.log);
  onINP(console.log);
  onLCP(console.log);
};

export default reportWebVitals;
